export function getDemoEnvironment(hostname: string): string | undefined {
	const changeengMatch = /^www\.(\w+)\.changeeng\.org$/.exec(hostname);
	if (changeengMatch) return changeengMatch[1];

	const previewOjosMatch = /^(preview-corgi-\d+)\.ojos-alligator\.ts\.net$/.exec(hostname);
	if (previewOjosMatch) return previewOjosMatch[1];

	return undefined;
}
